const baseJson = () => {
    return {
        id: null,
        name: null,
        users: null,
        ower: null,
        status: null,
        createdAt: null,
        modifiedAt: null,
        createdBy: null,
        modifiedBy: null,
    }
}

export const groupCongViecModel = {
    baseJson
}
